import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { paymentId, amount, memberName } = location.state || {};

  const handleBackToDashboard = () => {
    navigate('/member-dashboard');
  };

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">
          <svg viewBox="0 0 24 24" width="64" height="64">
            <circle cx="12" cy="12" r="11" fill="#4CAF50" />
            <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" fill="none" />
          </svg>
        </div>

        <h2>Payment Successful!</h2>

        {paymentId && amount && memberName ? (
          <div className="payment-details">
            <p><strong>Member:</strong> {memberName}</p>
            <p><strong>Amount:</strong> ₹{amount}</p>
            <p><strong>Payment ID:</strong> {paymentId}</p>
          </div>
        ) : (
          <p>Your payment has been processed successfully.</p>
        )}

        <button
          className="back-button"
          onClick={handleBackToDashboard}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;